import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import Modal from '../ui/Modal'
import SettingForm from './SettingFormik'

interface IServiceProgramAddModalProps {
  processing: boolean
  processingError: string
  routeProps: RouteComponentProps<any>
  onCreate: (name: string) => Promise<void>
}

export default class ServiceProgramAddModal extends React.Component<IServiceProgramAddModalProps> {
  public render() {
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center font-black'>
          <div className='bg-white col-4 relative'>
            <SettingForm
              title='ADD SERVICE PROGRAM'
              labelTitle='Service Program'
              onSubmit={this.handleSubmit}
              onSuccess={this.handleSubmitSuccess}
            >
              <button className='p1 font-grey h5 bg-white border-white mr1' onClick={this.handleCancelClick}>
                Cancel
              </button>
              <button className='pt1 pb1 pl2 pr2 border-radius h5 bg-green border-green font-white' type='submit'>
                Add
              </button>
            </SettingForm>
          </div>
        </div>
      </Modal>
    )
  }

  private handleCancelClick = () => {
    this.props.routeProps.history.push('/global-settings/service-program')
  }

  private handleSubmit = (label: string) => {
    return this.props.onCreate(label)
  }

  private handleSubmitSuccess = () => {
    setTimeout(() => {
      this.props.routeProps.history.push('/global-settings/service-program')
    }, 1000)
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/ServiceProgramAddModal.tsx